import PaymentMethodCategoryDTO from "features/payments/dtos/PaymentMethodCategoryDTO";
import PaymentMethodTypeEnumDTO from "features/shared/enums/dynamic/PaymentMethodTypeEnumDTO";
import {
  FormFields,
  FormValidations,
  SetValidationErrorFunction,
} from "features/shared/forms/hooks/useForm";
import { paymentCategoriesMapping } from "./paymentCategoriesMapping";

export const paymentMethodValidations = (): FormValidations => {
  return {
    DESC_TMSmluvniUcetVS: {
      required: true,
      type: "OnlyRequired",
    },
    DESC_TMMena: {
      required: true,
      type: "OnlyRequired",
    },
  };
};

export const validatePaymentMethods = (
  values: FormFields,
  paymentMethodTypes: PaymentMethodTypeEnumDTO[],
  setValidationError: SetValidationErrorFunction
): boolean => {
  let isValid = true;
  
  for (const paymentMethodCategory of paymentMethodTypes) {
    let descPrefix = paymentCategoriesMapping[paymentMethodCategory.code!];
    let selectedMethodId = values[`${descPrefix}Zpusob`];

    if (selectedMethodId) {
      let selectedPaymentMethod = paymentMethodCategory.categories?.find(x => x.paymentMethodTypeId === selectedMethodId);
      if (selectedPaymentMethod) {
        let isSelectedMethodValid = validateSelectedPaymentMethod(values, selectedPaymentMethod, descPrefix, setValidationError);
        if (!isSelectedMethodValid) {
          isValid = false;
        }
      }
    } else {
      setValidationError(`${descPrefix}Zpusob`, "required");
      isValid = false;
    }
  }

  return isValid;
}


const validateSelectedPaymentMethod = (
  values: FormFields,
  paymentMethod: PaymentMethodCategoryDTO,
  descPrefix: string,
  setValidationError: SetValidationErrorFunction
): boolean => {
  let isValid = true;

  switch (paymentMethod.accountType) {
    case "BankAccount":
    case "IBAN":
      if (paymentMethod.isAccountRequired) {
        let existingBankAccount = values[`${descPrefix}BankUcet`];
        let newBankAccount = values[`${descPrefix}CisloUctu`];
        if (existingBankAccount === undefined && newBankAccount === undefined) {
          setValidationError(`${descPrefix}BankUcet`, "required");
          isValid = false;
        }
      }
      break;
    case "Sipo":
      if (paymentMethod.isAccountRequired) {
        let existingSipo = values[`${descPrefix}CisloSipo`];
        let newSipo = values[`${descPrefix}SpojCislo`];
        if (existingSipo === undefined && newSipo === undefined) {
          setValidationError(`${descPrefix}CisloSipo`, "required");
          isValid = false;
        }
      }
      break;
    default:
      break;
  }
  
  return isValid;
};
